module.exports = __webpack_public_path__ + "static/media/celebrate.686156b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/celebrate.svg
// module id = 173
// module chunks = 0